import React from "react";
import "./Symbol.css";

const Symbol = () => {
  return (
    <div className="symbol">
      <div className="wrapper">
        <div className="symbol-intro-heading">
          <h2>„Wesele” jako dramat symboliczny</h2>
        </div>
      </div>
      <div className="symbol-specialization">
        <h3>Symbole w&nbsp;„Weselu”</h3>
        <p>
          Wyspiański w&nbsp;„Weselu” posługuje się wyrazistymi symbolami, które
          są nośnikami określonych znaczeń i&nbsp;funkcji. W&nbsp;dramacie
          odnajdziemy zatem &nbsp;
          <mark>symboliczne postaci, działania oraz rekwizyty</mark>. Cały akt
          II „Wesela” przybiera kształt swoistego seansu zjaw i&nbsp;duchów.
          Pojawiają się wówczas tacy symboliczni bohaterowie, jak&nbsp;
          <mark>
            <b>Widmo</b> (symbol romantycznej miłości), <b>Stańczyk</b> (symbol
            bezsilności),
            <b> Rycerz</b> (symbol marzeń o&nbsp;wielkich czynach),&nbsp;
            <b>Hetman </b>
            (symbol zdrady), <b>Jakub Szela</b> (symbol rzezi galicyjskiej) oraz
            <b> Wernyhora </b>
            (symbol narodowego odrodzenia)
          </mark>
          .
        </p>
        <br />
        <p>
          Symboliczna jest również czasoprzestrzeń utworu.
          <b> Bronowicki dwór</b>, niczym Mickiewiczowskie Soplicowo, stanowi
          niejako miniaturę całej Polski, w&nbsp;której współistnieją elementy
          chłopskie i&nbsp;szlacheckie. Ważną funkcję pełnią wiszące na ścianach
          obrazy:
          <mark> „Wernyhora” oraz „Bitwa pod Racławicami” Jana Matejki</mark>.
          Odnoszą się one do tych momentów polskiej historii, w&nbsp;których
          chłopi i&nbsp; inteligencja jednoczyli się w&nbsp;obronie ojczyzny.
        </p>
        <br />
        <p>
          Bardzo istotnym symbolem w&nbsp;dramacie jest <b>złoty róg</b>, który
          Wernyhora ofiarowuje <b>Gospodarzowi</b>.&nbsp;
          <mark>
            Jego dźwięk ma przebudzić uśpione serca rodaków i&nbsp;przygotować
            ich do walki o&nbsp;wolność
          </mark>
          . <b>Gospodarz</b> oddaje jednak <b>złoty róg Jaśkowi</b>, a&nbsp;sam
          zasypia.&nbsp;
          <mark>
            Gest ów oznacza, że inteligencja nie chce pełnić przewodniej roli
            i&nbsp;zrzeka się jej
          </mark>
          . Zgubienie <b>złotego rogu</b> przez chłopa stanowi zaś&nbsp;
          <mark>symbol zaprzepaszczenia szansy na odzyskanie wolności</mark>.
        </p>
        <br />
        <p>
          Ważna jest również <b>czapka z&nbsp;pawimi piórami</b>, po którą
          schyla się Jasiek, gubiąc przy okazji <b>złoty róg Wernyhory</b>.
          Oznacza ona&nbsp;
          <mark>przywiązanie chłopstwa do wartości materialnych</mark>, które są
          dla nich najważniejsze. Z&nbsp;kolei <b>sznur</b> zostający
          w&nbsp;rękach chłopca po zgubie&nbsp;
          <mark>przypomina zaś o&nbsp;zniewoleniu Polaków</mark>.
        </p>
        <br />
        <p>
          Pozytywnym symbolem w&nbsp;„Weselu” jest natomiast <b>chochoł </b>
          jako snop okrywający podczas zimy krzak róży. Można bowiem
          przypuszczać, że&nbsp;podobnie jak chochoł jest zrzucany na wiosnę,
          tak <mark>Polacy zrzucą kajdany i&nbsp;odzyskają niepodległość</mark>.
          Z&nbsp;kolei
          <b> chocholi korowód</b> w&nbsp;końcowej scenie dramatu stanowi&nbsp;
          <mark>symbol marazmu i&nbsp;zniewolenia polskiego społeczeństwa</mark>
          .
        </p>
        <br />
        <p>
          <em>
            wypracowania.pl/wypracowania/wesele-jako-dramat-symboliczny-symbole-w-weselu
          </em>
        </p>
      </div>
    </div>
  );
};

export default Symbol;
